module.exports = __webpack_public_path__ + "img/newzealand.60da92eb.svg";